export default {
  scenes: {
    newBeginning: {
      beats: {
        aftermath: {
          events: [
            {
              type: 'showLocation',
              locationId: 'negotiationRoom'
            },
            {
              type: 'showNarration',
              text: 'With Orion captured, Elena\'s team returns to the negotiation table, now with a renewed sense of purpose. The factions, though still wary, recognize the gravity of the situation. Elena uses the intel she recovered from Orion, along with her own diplomatic skills, to craft a new peace agreement that includes provisions for both factions to work together. It\'s a delicate balance, but one that has the potential to change the galaxy\'s future.'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'How does Elena approach the final negotiations?',
              choices: [
                {
                  text: 'Propose a Bold Compromise',
                  next: {
                    scene: 'newBeginning',
                    beat: 'boldCompromise'
                  }
                },
                {
                  text: 'Take a More Cautious Approach',
                  next: {
                    scene: 'newBeginning',
                    beat: 'cautiousApproach'
                  }
                }
              ]
            }
          ]
        },
        boldCompromise: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'We need to move beyond old grudges. A real peace can only come if both sides are willing to make sacrifices.'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'neutral',
              text: 'It\'s a risky move, but it could work.'
            },
            {
              type: 'hideCharacter',
              characterId: 'zara',
              position: 'center'
            }
          ],
          next: {
            scene: 'newBeginning',
            beat: 'agreement'
          }
        },
        cautiousApproach: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'Let\'s find a way that respects both sides\' needs while also pushing for unity. We\'ll take it one step at a time.'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'neutral',
              text: 'Slow and steady. That\'s the way to go.'
            },
            {
              type: 'hideCharacter',
              characterId: 'kael',
              position: 'center'
            }
          ],
          next: {
            scene: 'newBeginning',
            beat: 'agreement'
          }
        },
        agreement: {
          events: [
            {
              type: 'showNarration',
              text: 'After hours of tense discussions, a peace agreement is reached. The factions agree to a ceasefire, and Elena\'s leadership is praised for her ability to bring them together. While the agreement is not perfect, it\'s a beginning. Elena feels the weight of the responsibility lifting off her shoulders, but she knows there\'s still work to be done to ensure the lasting success of the treaty.'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'How does Elena celebrate the success?',
              choices: [
                {
                  text: 'Share the Victory with Her Team',
                  next: {
                    scene: 'newBeginning',
                    beat: 'shareVictory'
                  }
                },
                {
                  text: 'Reflect on the Journey Alone',
                  next: {
                    scene: 'newBeginning',
                    beat: 'reflectAlone'
                  }
                }
              ]
            }
          ]
        },
        shareVictory: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'happy',
              text: 'We did it, team. This victory is yours as much as it is mine.'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'happy',
              text: 'You led us through this, Captain. We couldn\'t have done it without you.'
            },
            {
              type: 'hideCharacter',
              characterId: 'zara',
              position: 'center'
            }
          ],
          next: {
            scene: 'newBeginning',
            beat: 'momentOfReflection'
          }
        },
        reflectAlone: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'thinking',
              text: 'We\'ve come so far. It\'s hard to believe it\'s really over.'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'neutral',
              text: 'You\'ve earned this moment. Don\'t forget to enjoy it.'
            },
            {
              type: 'hideCharacter',
              characterId: 'zara',
              position: 'center'
            }
          ],
          next: {
            scene: 'newBeginning',
            beat: 'momentOfReflection'
          }
        },
        momentOfReflection: {
          events: [
            {
              type: 'showLocation',
              locationId: 'starryView'
            },
            {
              type: 'showNarration',
              text: 'As the peace talks end and Elena prepares to leave the planet, she takes a moment to look out over the vast, starry sky. The weight of her journey, the relationships she\'s formed, and the choices she\'s made come flooding back. She knows this isn\'t the end—peace is a continuous effort. But for now, she\'s proud of what they\'ve accomplished.'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'thinking',
              text: 'This was worth it. For the galaxy, for the people, for us.'
            }
          ],
          next: {
            scene: 'callOfFuture',
            beat: 'unexpectedMessage'
          }
        }
      }
    },
    callOfFuture: {
      beats: {
        unexpectedMessage: {
          events: [
            {
              type: 'showLocation',
              locationId: 'starshipBridge'
            },
            {
              type: 'showNarration',
              text: 'Back on her ship, Elena receives a mysterious transmission. It\'s from an unknown source, and the message is cryptic. The transmission hints at an even larger threat looming on the horizon—one that could put the peace Elena fought for at risk. Though the peace agreement has just been signed, it\'s clear there\'s more work to be done to secure the future of the galaxy.'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'How does Elena handle the cryptic message?',
              choices: [
                {
                  text: 'Investigate Immediately',
                  next: {
                    scene: 'callOfFuture',
                    beat: 'investigateImmediately'
                  }
                },
                {
                  text: 'Stay Focused on the Peace Efforts',
                  next: {
                    scene: 'callOfFuture',
                    beat: 'stayFocused'
                  }
                }
              ]
            }
          ]
        },
        investigateImmediately: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'We can\'t ignore this. If there\'s another threat out there, we need to face it head-on.'
            },
            {
              type: 'showCharacter',
              characterId: 'kael',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'kael',
              variation: 'neutral',
              text: 'We\'re ready when you are, Elena.'
            },
            {
              type: 'hideCharacter',
              characterId: 'kael',
              position: 'center'
            }
          ],
          next: {
            scene: 'callOfFuture',
            beat: 'preparingForUnknown'
          }
        },
        stayFocused: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'We can\'t let this distract us from the task at hand. The peace agreement must come first.'
            },
            {
              type: 'showCharacter',
              characterId: 'zara',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'zara',
              variation: 'neutral',
              text: 'But we should keep an eye on things. No need to rush into unknown danger.'
            },
            {
              type: 'hideCharacter',
              characterId: 'zara',
              position: 'center'
            }
          ],
          next: {
            scene: 'callOfFuture',
            beat: 'preparingForUnknown'
          }
        },
        preparingForUnknown: {
          events: [
            {
              type: 'showNarration',
              text: 'Elena and her team begin to prepare for whatever may lie ahead. Whether the threat is real or just a distraction, they know they must stay vigilant. They gather their resources and prepare to face the unknown, knowing that the peace they\'ve just secured is only the beginning of a much larger journey.'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'neutral',
              text: 'We\'ll be ready for whatever comes next. Together, we\'ll face whatever the galaxy throws our way.'
            }
          ],
          next: {
            scene: 'callOfFuture',
            beat: 'unseenFuture'
          }
        },
        unseenFuture: {
          events: [
            {
              type: 'showNarration',
              text: 'As Elena gazes into the vast unknown, she knows this mission will be only one of many to come. The future is uncertain, but with her team by her side and the lessons she\'s learned, she is more prepared than ever to lead. The galaxy may be filled with danger, but it\'s also full of opportunities for those brave enough to take them.'
            },
            {
              type: 'showCharacter',
              characterId: 'elena',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'elena',
              variation: 'happy',
              text: 'The future awaits. And we\'ll face it, no matter what.'
            },
            {
              type: 'showNarration',
              text: 'The End... for now'
            }
          ],
          goToGameOver: true
        }
      }
    }
  }
}
